import { useQuery } from '@tanstack/react-query';

import { statsApi } from '../stats.api';

import { StatsQueryParams } from './types';

export const useQueryStatsAOGDR = ({
  dateTo,
  fromUnitType,
  fromValue,
  aircraftsIdList = [],
}: StatsQueryParams) => {
  const enabled = ![fromUnitType, fromValue, dateTo].some(v => v === undefined);
  const dateToString = dateTo.toISOString();
  return useQuery({
    queryKey: [
      'StatsAOGDR',
      fromValue,
      fromUnitType,
      dateToString,
      aircraftsIdList,
    ],
    queryFn: async () =>
      statsApi.getAogdr({
        dateTo,
        fromValue,
        fromUnitType,
        aircraftsIdList,
      }),
    enabled,
  });
};
